import { IDmLoaiThuChi } from "../../model/respone/category/IDmLoaiThuChi";
import { apiClient } from "../apiClient";
export const LOAI_THU_CHI_ENDPOINT = "loai-thu-chi";
export const loaiThuChiApi = {
  SelectAll: () => apiClient.get(`${LOAI_THU_CHI_ENDPOINT}`),
  Insert: (payload: IDmLoaiThuChi) =>
    apiClient.post(`${LOAI_THU_CHI_ENDPOINT}`, payload),
  Update: (payload: IDmLoaiThuChi) =>
    apiClient.put(`${LOAI_THU_CHI_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${LOAI_THU_CHI_ENDPOINT}/${id}`),
  DeleteMany: (ids: number[]) =>
    apiClient.post(`${LOAI_THU_CHI_ENDPOINT}/delete-many`, ids),
};
